import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import FilterList from "../../components/FilterList";
import CardList from "../../components/CardList";
import LeadForm from "../../components/LeadForm";
import "./style.scss";

function DayPass() {
  const [accessKey, setAccessKey] = useState("");
  const [filterData, setFilterData] = useState(null);
  const [filterCityData, setFilterCityData] = useState(null);

  useEffect(() => {
    let url = window.location.pathname;
    let access_key = url.split("/day-pass/")[1];
    setAccessKey(access_key);
  }, [window.location.pathname]);

  return (
    <>
      <Header accessKey={accessKey} queryParams={window.location.origin + `/day-pass/${accessKey}`} dayPass={true} />
      <div className="page-content">
        <div className="main-content">
          <FilterList
            onFilterDataChange={(data) => setFilterData(data)}
            onFilterCityData={(data) => setFilterCityData(data)}
          />
          <CardList filterData={filterData} />
        </div>
        <div className="sidebar">
          <LeadForm onFilterCityData={filterCityData} />
        </div>
      </div>
    </>
  );
}

export default DayPass;
